import { render, staticRenderFns } from "./InfoCenter.vue?vue&type=template&id=0c27ca68&scoped=true"
import script from "./InfoCenter.vue?vue&type=script&lang=js"
export * from "./InfoCenter.vue?vue&type=script&lang=js"
import style0 from "./InfoCenter.vue?vue&type=style&index=0&id=0c27ca68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c27ca68",
  null
  
)

export default component.exports